import * as React from "react";
const SvgFiRrStageTheatre = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stage-theatre_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v15c0 2.243 1.792 4 4.08 4h1.913c.6 0 1.165-.265 1.55-.727.374-.448.53-1.03.427-1.598-.51-2.803-2.565-5.034-4.225-6.431 2.6-1.006 6.453-3.28 8.257-8.196 1.803 4.917 5.656 7.19 8.257 8.196-1.661 1.396-3.715 3.627-4.225 6.431a1.95 1.95 0 0 0 .427 1.598c.385.462.95.727 1.55.727h1.913c2.288 0 4.08-1.757 4.08-4V5c0-2.757-2.243-5-5-5zM5.992 22H4.079c-1.166 0-2.08-.879-2.08-2v-3.592C3.468 17.555 5.55 19.564 5.992 22M2 13.754V5c0-1.654 1.346-3 3-3h1.961c-.185 2.485-1.07 4.487-2.643 5.958a1 1 0 1 0 1.365 1.46C7.671 7.561 8.765 5.064 8.96 1.999h2.014c-.44 8.447-6.416 11.032-8.973 11.754zM13.027 2h2.014c.195 3.065 1.289 5.561 3.277 7.419.193.181.438.27.683.27a1 1 0 0 0 .682-1.73c-1.574-1.471-2.459-3.473-2.643-5.958h1.961c1.654 0 3 1.346 3 3v8.759c-2.558-.71-8.536-3.274-8.973-11.759zM22 20c0 1.121-.914 2-2.08 2l-1.921.033c.447-2.456 2.531-4.474 4.001-5.624z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stage-theatre_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStageTheatre;
